// extracted by mini-css-extract-plugin
module.exports = {"uploadWidget":"UploadWidget_uploadWidget__32Mw3","complete":"UploadWidget_complete__1z6Hg","progress":"UploadWidget_progress__2HDNT"};